import React, { useRef } from 'react';
import Slider from 'react-slick';
import './Stlye.css';
import backgroundImage from './images/theme-13.webp';
import angelImg from './images/angel_investor1.webp';
import dataconsImg from './images/data-consulting.webp';
import hospitalityImg from './images/hospitality.jpg';
import managementImg from './images/management_consulting_banner.jpg';
import softwareImg from './images/software_banner.jpg';
import { NavLink } from 'react-router-dom';
import { CustomPrevArrow, CustomNextArrow } from './customArrow';

const ServicesSection = () => {
  const sliderRef = useRef(null);

  const settings = {
    dots: false,
    arrows: true,
    centerMode: true,
    centerPadding: '20px',
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    draggable: false,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          centerMode: false,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const slides = [
    {
      title: 'Software & Web Development',
      image: softwareImg,
      description:
        'Smart Resources QLD provides professional software and web development services in Queensland, helping businesses design, build, and maintain tailored, scalable software systems and responsive websites.',
      link: '/operations/software-web-development',
    },
    {
      title: 'Synthetic Data Services',
      image: dataconsImg,
      description:
        'Build and train machine learning models without exposing customer records, utilizing privacy-first synthetic data services for regulatory compliance.',
      link: '/operations/data-science-services-australia',
    },
    {
      title: 'Angel Investor',
      image: angelImg,
      description:
        'Empower promising ventures and fuel innovation as an angel investor with Smart Resources, leveraging our network, expertise, and resources for impactful investments.',
      link: '/operations/angel-investor',
    },
    {
      title: 'Hospitality Operations',
      image: hospitalityImg,
      description:
        'Smart Resources QLD is involved in hospitality business operations through Punjabi Palace Brisbane and Punjabi Palace Cairns, with a focus on service quality and long-term sustainability.',
      link: '/operations/hospitality',
    },
    {
      title: 'Management Consulting',
      image: managementImg,
      description:
        'Smart Resources QLD provides management consulting services focused on business planning, strategic forecasting, process improvement, workflow management, and financial operations support.',
      link: '/operations/management-consulting',
    },
  ];

  return (
    <section className="services" style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className="innr_services">
        <div className="serv_heading">
          <div className="serv_heading_left">
            <div className="about_left_heading">
              <div className="abt_sub_title">Services</div>
              <h3 data-aos="fade-right" aos-anchor-placement="top-center">
                We deal with many services to take extra care of your problem solutions
              </h3>
            </div>
          </div>
          <div className="serv_heading_right">
            <div className="about_right_heading121" data-aos="fade-right" aos-anchor-placement="top-center">
              <p>
                Discover our range of specialized services designed to propel your business forward. From strategic consulting to innovative solutions, we're committed to delivering excellence tailored to your unique needs.
              </p>
            </div>
          </div>
        </div>

        <Slider ref={sliderRef} {...settings} className="slick_serv">
          {slides.map((slide, index) => (
            <div key={index} className="slick_innr_serv" style={{ display: 'flex', flexDirection: 'column', height: '540px', justifyContent: 'space-between', padding: '30px 25px 25px 25px' }}>
              <div>
                <div className="item--icon" style={{ height: '190px', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', borderRadius: '15px', marginBottom: '20px' }}>
                  <img src={slide.image} alt={slide.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </div>
                <h3 style={{ fontSize: '18px', minHeight: '48px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '15px' }}>
                  <NavLink to={slide.link} style={{ color: '#0e0e0e', fontWeight: '700', textDecoration: 'none' }}>{slide.title}</NavLink>
                </h3>
                <div className="item_content_serv">
                  <p style={{ fontSize: '14px', lineHeight: '22px', color: '#555', margin: '0' }}>{slide.description}</p>
                </div>
              </div>
              <div className="entry-readmore-react" style={{ marginTop: '20px' }}>
                <NavLink to={slide.link} onClick={() => window.scrollTo(0, 0)} style={{ fontWeight: '600', textDecoration: 'none', color: '#800020' }}>
                  Read more <i className="fa-solid fa-angles-right"></i>
                </NavLink>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default ServicesSection;
